import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {IStudyItem} from "../../models/study.item";

@Component({
	selector:'cp-study-item',
	templateUrl: './study.item.template.html',
	styleUrls: ['./study.item.style.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class StudyItemComponent {
	@Input() study: IStudyItem;
	@Input() displayDate: boolean;
	@Input() selected:boolean;
	@Input() active:boolean;
}
